import React, { useState } from 'react'
import axios from 'axios'
import SideBar from '../../SideBar'
import { useEffect } from 'react'
import { ExcelExport } from '@progress/kendo-react-excel-export'
import { ExcelExportColumn } from '@progress/kendo-react-excel-export'
import { useLocation, Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import { Input } from '@nextui-org/react'

import {
  FaCashRegister,
  FaFileMedical,
  FaPenSquare,
  FaPaperPlane,
  FaRegEdit,
  FaRegTrashAlt
} from 'react-icons/fa'
import HeaderName from '../../HeaderName'
import { useSelector } from 'react-redux'
const Income = () => {
  const token = localStorage.getItem('token')
  const url = process.env.REACT_APP_APP_URL
  // const url = "http://192.168.1.15:4000/api/";
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  })

  const [stockTranLists, setStockTranLists] = useState([])

  const [stockReqLists, setStockReqLists] = useState([])
  const [reqCount, setReqCount] = useState('')
  const [showOrigin, setShowOrigin] = useState(true)
  const [showSearchDate, setShowSearchDate] = useState(false)
  const [to, setTo] = useState('')
  const [from, setFrom] = useState('')
  const [searchByDateList, setSearchByDateList] = useState([])

  const [searchList, setSearchList] = useState([])
  const [showSearch, setShowSearch] = useState(false)
  const [showOri, setShowOri] = useState(true)
  const [branchesLists, setBranchesLists] = useState([])
  const [branchFilterLists, setBranchFilterLists] = useState([])
  const [showBranchFilter, setShowBranchFilter] = useState(false)
  const [reqID, setReqID] = useState('')
  const TreatId = useLocation().pathname.split('/')[2]

  // const _export = React.useRef(null);
  // const excelExport = () => {
  //   if (_export.current !== null) {
  //     console.log(_export.current.props.data);
  //     _export.current.props.data.map(function (element, index) {
  //       element.date = element.date.split("T")[0];
  //     });
  //     _export.current.save();
  //   }
  // };
  const handleChoose = event => {
    console.log(event, 'branch')

    setBranchFilterLists(
      stockReqLists.filter(el => el.relatedBranch._id == event)
    )

    setShowOrigin(false)

    setShowBranchFilter(true)
    setShowSearchDate(false)
  }

  const handleFilterDate = () => {
    console.log(from, 'from')
    console.log(to, 'to')
    setSearchByDateList(
      stockReqLists.filter(
        el => el.date >= from && (el.date = to || el.date < to)
      )
    )

    setShowSearchDate(false)
    setShowSearchDate(true)
    setShowBranchFilter(false)

    setShowOrigin(false)
  }

  const handleDelete = event => {
    api
      .delete('stock-request/' + event)
      .then(response => {
        Swal.fire({
          title: 'Success',
          text: 'Successfully Deleted!',
          icon: 'success',
          confirmButtonText: 'OK'
        })
        const result = stockReqLists.filter(item => item._id !== event)
        setStockReqLists(result)
      })
      .catch(error => {
        Swal.fire({
          title: 'Error',
          text: error.response.data.message,
          icon: 'error',
          confirmButtonText: 'CANCEL'
        })
      })
  }

  const search = val => {
    if (val) {
      setSearchList(
        stockReqLists.filter(
          el =>
            el.requestedBy.toLowerCase().includes(val.toLowerCase()) ||
            el.requestNo.toLowerCase().includes(val.toLowerCase())
        )
      )
      setShowSearch(true)

      setShowSearchDate(false)

      setShowOrigin(false)
    } else {
      setShowSearch(false)

      setShowSearchDate(false)

      setShowOrigin(true)
    }
  }
  useEffect(() => {
    const getStockReqLists = async () => {
      try {
        const res = await api.get('stock-requests')
        setStockReqLists(res.data.list)
        // console.log(res.data.list,'req li')
        setReqCount(res.data.list.filter(el => !el.relatedTransfer).length)
        // setTreatmentLists(res.data.list)
        setReqID(res.data.list._id)

        console.log(res.data.list, 'sq lis')
      } catch (err) {
        alert(err.message)
      }
    }

    const getStockTranLists = async () => {
      try {
        const res = await api.get(
          'stock-transfers'
          //'http://localhost:9000/api/treatments'
        )
        setStockTranLists(res.data.list)

        // setTreatmentLists(res.data.list)

        console.log(res.data.list, 'tran')
      } catch (err) {
        alert(err.message)
      }
    }

    const getBranches = async () => {
      try {
        const res = await api.get('branches')
        setBranchesLists(res.data.list)
      } catch (err) {
        alert(err.message)
      }
    }
    getStockTranLists()

    getBranches()
    getStockReqLists()
  }, [])

  return (
    <div classNameName='App'>
      <div className='wrapper'>
        <HeaderName />

        {/* <!-- /.navbar --> */}

        {/* <!-- Main Sidebar Container --> */}
        <SideBar />

        {/* <!-- Content Wrapper. Contains page content --> */}
        <div className='content-wrapper'>
          {/* <!-- Content Header (Page header) --> */}
          <div className='content-header'>
            <div className='container-fluid'>
              <div className='row mb-2'>
                <div className='col-sm-12'>
                  <ol className='breadcrumb'>
                    <li className='breadcrumb-item active'>
                      Stock Request List &nbsp;
                      <b className='bg-red rounded-4 px-2 py-1'>{reqCount}+</b>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Main content --> */}

          <section className='content'>
            <div className='container-fluid'>
              <div className='row'>
                <div className='col-6'>
                  <div className='row'>
                    <div className='form-group col-md-3'>
                      <label>From</label>
                      <input
                        type='date'
                        name='from'
                        id='from'
                        onChange={e => setFrom(e.target.value)}
                        className='form-control'
                      />
                    </div>
                    <div className='form-group col-md-3'>
                      <label>To</label>
                      <input
                        type='date'
                        name='to'
                        id='to'
                        onChange={e => setTo(e.target.value)}
                        className='form-control'
                      />
                    </div>
                    <div className='form-group col-md-2'>
                      <button
                        className='btn btn-sm btn-primary'
                        style={{ marginTop: '40px' }}
                        onClick={handleFilterDate}
                      >
                        Search
                      </button>
                    </div>
                    <div className='col-4' style={{ marginTop: '2.6em' }}>
                      <div className='form-group'>
                        <select
                          name='currency'
                          id=''
                          className='form-control '
                          // onchange='convert(this.value)'
                          // placeholder='Filter By Branches'
                          onChange={e => handleChoose(e.target.value)}
                        >
                          <option hidden>Filter By Branches</option>
                          {branchesLists.map((option, i) => (
                            <option value={option._id}>{option.name}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='offset-2 col-4' style={{ marginTop: '2.3em' }}>
                  <div className='row'>
                    <div className='offset-4 col-md-6'>
                      <Input
                        type='search'
                        className='form-control rounded ml-1'
                        style={{ borderRadius: '12px' }}
                        id='search_code'
                        labelPlaceholder='Search'
                        onChange={e => search(e.target.value)}
                      />
                    </div>
                    {/* <div className='col-md-6 '>
                      <Link
                        to='/stock-req-create'
                        className='btn btn-dark'
                        style={{
                          borderRadius: '7px',
                          backgroundColor: 'dark',
                          color: 'white'
                        }}
                      >
                        Create
                      </Link>
                    </div> */}
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-12'>
                  <div className='card'>
                    {/* <div className="card-header">
                      <div className="row justify-content-between">
                        <span className="float-right">
                          <a href="/income_type" className="btn btn-primary">
                            Income Type
                          </a>
                           <button
                              type="button"
                              className="btn btn-primary"
                              onClick={excelExport}>
                              Export Excel
                            </button>
                        </span>
                      </div>
                      <div className="row" id="trial_balance"></div>
                    </div> */}

                    <div className='card-body'>
                      {/* Export data in Excel */}
                      {/* <ExcelExport data={incomeLists} ref={_export}>
                        <ExcelExportColumn
                          field=""
                          title="No"
                          locked={true}
                          width={30}
                        />
                        <ExcelExportColumn
                          field="date"
                          title="Date"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={200}
                        />

                        <ExcelExportColumn
                          field="relatedBankAccount.name"
                          title="Bank Account"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />

                        <ExcelExportColumn
                          field="relatedCashAccount.name"
                          title="Cash Account"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />

                        <ExcelExportColumn
                          field="relatedAccounting.name"
                          title="Account"
                          width={150}
                        />
                        <ExcelExportColumn
                          field="remark"
                          title="Remark"
                          width={150}
                        />
                      </ExcelExport> */}
                      {/* Export Data in Excel end */}
                      <div className='row'>
                        <div className='col-md-12'>
                          <div
                            className='table-responsive text-black'
                            id='slimtest2'
                          >
                            <table
                              className='table table-hover'
                              id='filter_date'
                            >
                              <thead>
                                <tr>
                                  <th>#</th>
                                  <th>Date</th>
                                  <th>Request No</th>
                                  <th>Branch Request No</th>
                                  <th>Request By</th>
                                  {/* <th>Doctor</th> */}
                                  <th>Branch</th>

                                  {/* <th>Check</th> */}
                                  <th className='text-center'>Action</th>
                                </tr>
                              </thead>

                              {showSearch && (
                                <tbody>
                                  {searchList[0] ? searchList.map((sq, i) => (
                                    <tr>
                                      <td>{++i}</td>
                                      <td>
                                        {sq.date ? sq.date.split('T')[0] : ''}
                                      </td>
                                      <td>{sq.requestNo}</td>
                                      <td>
                                        {sq.branchRequestCode
                                          ? sq.branchRequestCode
                                          : '-'}
                                      </td>
                                      <td>{sq.requestedBy}</td>
                                      <td>{sq.relatedBranch.name}</td>
                                      <td className='text-center'>
                                        {/* <Link
                                          to={'/sq-Update/' + sq._id}
                                          className='btn btn-sm btn-warning'
                                        >
                                          <FaRegEdit />
                                        </Link> */}
                                        &nbsp;
                                        {/* <button
                                          className='btn btn-sm btn-danger'
                                          onClick={e => handleDelete(sq._id)}
                                        >
                                          <FaRegTrashAlt />
                                        </button> */}
                                        &nbsp;
                                        {sq.relatedTransfer?._id ? (
                                          <button
                                            className='btn btn-sm btn-info'
                                            disabled
                                            style={{
                                              borderRadius: '7px',

                                              color: 'white'
                                            }}
                                          >
                                            <FaPaperPlane />
                                          </button>
                                        ) : (
                                          <Link
                                            to={'/stock-tran-create/' + sq._id}
                                            className='btn btn-sm btn-info'
                                            style={{
                                              borderRadius: '7px',

                                              color: 'white'
                                            }}
                                          >
                                            <FaPaperPlane />
                                          </Link>
                                        )}
                                      </td>
                                    </tr>
                                  )) : (
                                    <span>Loading ...</span>
                                  )}
                                </tbody>
                              )}

                              {showOrigin && (
                                <tbody>
                                  {stockReqLists[0] ? stockReqLists.map((sq, i) => (
                                    <tr>
                                      <td>{++i}</td>
                                      <td>
                                        {sq.date ? sq.date.split('T')[0] : ''}
                                      </td>
                                      <td>{sq.requestNo}</td>
                                      <td>
                                        {sq.branchRequestCode
                                          ? sq.branchRequestCode
                                          : '-'}
                                      </td>

                                      <td>{sq.requestedBy}</td>

                                      <td>{sq.relatedBranch.name}</td>

                                      <td className='text-center'>
                                        {/* <Link
                                          to={'/sq-Update/' + sq._id}
                                          className='btn btn-sm btn-warning'
                                        >
                                          <FaRegEdit />
                                        </Link> */}
                                        &nbsp;
                                        {/* <button
                                          className='btn btn-sm btn-danger'
                                          onClick={e => handleDelete(sq._id)}
                                        >
                                          <FaRegTrashAlt />
                                        </button> */}
                                        &nbsp;
                                        {sq.relatedTransfer?._id ? (
                                          <button
                                            type='button'
                                            className='btn btn-sm btn-info'
                                            disabled
                                            style={{
                                              borderRadius: '7px',

                                              color: 'white'
                                            }}
                                          >
                                            <FaPaperPlane />
                                          </button>
                                        ) : (
                                          <Link
                                            to={'/stock-tran-create/' + sq._id}
                                            className='btn btn-sm btn-info'
                                            style={{
                                              borderRadius: '7px',

                                              color: 'white'
                                            }}
                                          >
                                            <FaPaperPlane />
                                          </Link>
                                        )}
                                      </td>
                                    </tr>
                                  )) : (
                                    <span>Loading ...</span>
                                  )}
                                </tbody>
                              )}
                              {showBranchFilter && (
                                <tbody>
                                  {branchFilterLists[0] ? branchFilterLists.map((sq, i) => (
                                    <tr>
                                      <td>{++i}</td>
                                      <td>
                                        {sq.date ? sq.date.split('T')[0] : ''}
                                      </td>
                                      <td>{sq.requestNo}</td>
                                      <td>
                                        {sq.branchRequestCode
                                          ? sq.branchRequestCode
                                          : '-'}
                                      </td>

                                      <td>{sq.requestedBy}</td>

                                      <td>{sq.relatedBranch.name}</td>

                                      <td className='text-center'>
                                        {/* <Link
                                          to={'/sq-Update/' + sq._id}
                                          className='btn btn-sm btn-warning'
                                        >
                                          <FaRegEdit />
                                        </Link> */}
                                        &nbsp;
                                        {/* <button
                                          className='btn btn-sm btn-danger'
                                          onClick={e => handleDelete(sq._id)}
                                        >
                                          <FaRegTrashAlt />
                                        </button> */}
                                        &nbsp;
                                        {sq.relatedTransfer?._id ? (
                                          <button
                                            className='btn btn-sm btn-info'
                                            disabled
                                            style={{
                                              borderRadius: '7px',

                                              color: 'white'
                                            }}
                                          >
                                            <FaPaperPlane />
                                          </button>
                                        ) : (
                                          <Link
                                            to={'/stock-tran-create/' + sq._id}
                                            className='btn btn-sm btn-info'
                                            style={{
                                              borderRadius: '7px',

                                              color: 'white'
                                            }}
                                          >
                                            <FaPaperPlane />
                                          </Link>
                                        )}
                                      </td>
                                    </tr>
                                  )) : (
                                    <span>Loading ...</span>
                                  )}
                                </tbody>
                              )}
                              {showSearchDate && (
                                <tbody>
                                  {searchByDateList[0] ? searchByDateList.map((sq, i) => (
                                    <tr>
                                      <td>{++i}</td>
                                      <td>
                                        {sq.date ? sq.date.split('T')[0] : ''}
                                      </td>
                                      <td>{sq.requestNo}</td>
                                      <td>
                                        {sq.branchRequestCode
                                          ? sq.branchRequestCode
                                          : '-'}
                                      </td>
                                      <td>{sq.requestedBy}</td>

                                      <td>{sq.relatedBranch.name}</td>

                                      <td className='text-center'>
                                        {/* <Link
                                          to={'/sq-Update/' + sq._id}
                                          className='btn btn-sm btn-warning'
                                        >
                                          <FaRegEdit />
                                        </Link> */}
                                        &nbsp;
                                        {/* <button
                                          className='btn btn-sm btn-danger'
                                          onClick={e => handleDelete(sq._id)}
                                        >
                                          <FaRegTrashAlt />
                                        </button> */}
                                        &nbsp;
                                        {sq.relatedTransfer?._id ? (
                                          <button
                                            className='btn btn-sm btn-info'
                                            disabled
                                            style={{
                                              borderRadius: '7px',

                                              color: 'white'
                                            }}
                                          >
                                            <FaPaperPlane />
                                          </button>
                                        ) : (
                                          <Link
                                            to={'/stock-tran-create/' + sq._id}
                                            className='btn btn-sm btn-info'
                                            style={{
                                              borderRadius: '7px',

                                              color: 'white'
                                            }}
                                          >
                                            <FaPaperPlane />
                                          </Link>
                                        )}
                                      </td>
                                    </tr>
                                  )) : (
                                    <span>Loading ...</span>
                                  )}
                                </tbody>
                              )}
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <Treatement
                open={open}
                close={() => setOpen(false)}
                setTreatmentLists={setTreatmentLists}
                treatmentLists={treatmentLists}
              /> */}
            </div>
          </section>
        </div>
      </div>
      {/* <!-- /.content-wrapper --> */}
      <footer className='main-footer text-center'>
        <strong>
          Copyright &copy; 2017-2020{' '}
          <a href='http://www.kwintechnologies.com'>K-win Technology</a>.
        </strong>
        All rights reserved.
      </footer>

      {/* <!-- Control Sidebar --> */}
      <aside className='control-sidebar control-sidebar-dark'>
        {/* <!-- Control sidebar content goes here --> */}
      </aside>

      {/* <!-- ./wrapper --> */}
    </div>
  )
}

export default Income
